import { render, staticRenderFns } from "./MarketOrderTableVariantTotal.vue?vue&type=template&id=35fb02a2&"
import script from "./MarketOrderTableVariantTotal.vue?vue&type=script&lang=js&"
export * from "./MarketOrderTableVariantTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports